import { useState, useId } from 'react'
import { Props_SnippetTabSwitcher } from './TabSwitcher.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetTabSwitcher = (props: Props_SnippetTabSwitcher) => {
    const { snippet, heading, repeatable_tab } = props

    const [activeTab, setActiveTab] = useState<number>(0)
    const snippetID = useId()
    const classSnippetTheme: string = snippet.theme.value ? `snippet-tab-switcher--theme-${snippet.theme.value}` : ''
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-tab-switcher__heading--${heading.visibility.value}` : ''

    return (
        <section className={`snippet-tab-switcher ${classSnippetTheme}`}>
            <div className="snippet-tab-switcher__container">
                <h2 id={`snippet-tab-switcher-${snippetID}`} className={`snippet-tab-switcher__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                <div className="snippet-tab-switcher__container-wrapper">
                    <div
                        role="tablist"
                        aria-labelledby={`snippet-tab-switcher-${snippetID}`}
                        className="snippet-tab-switcher__container-tabs"
                    >
                        {repeatable_tab.map((tab, index) => (
                            <button
                                key={`snippet-tab-switcher-${snippetID}-${index}`}
                                role="tab"
                                aria-selected={activeTab === index}
                                aria-controls={`snippet-tab-switcher-${snippetID}-${index}`}
                                className="snippet-tab-switcher__tabs-button"
                                onClick={() => setActiveTab(index)}
                            >
                                {tab?.label?.value}
                            </button>
                        ))}
                    </div>
                    <div className="snippet-tab-switcher__container-content">
                        {repeatable_tab.map((tab, index) => (
                            <article
                                key={`snippet-tab-switcher-${snippetID}-${index}`}
                                id={`snippet-tab-switcher-${snippetID}-${index}`}
                                role="tabpanel"
                                aria-hidden={activeTab !== index}
                                className="snippet-tab-switcher__tab"
                            >
                                <div className="snippet-tab-switcher__tab-container">
                                    <div className="snippet-tab-switcher__tab-container-content">
                                        <h3 className="snippet-tab-switcher__tab-heading">{tab.heading?.value}</h3>
                                        {tab.content?.value && <div className="snippet-tab-switcher__tab-content">{Legacy_CompileMarkdown(tab.content.value)}</div>}
                                        {tab.linkText?.value && tab.url?.value && (
                                            <a
                                                href={tab.url.value}
                                                className="snippet-tab-switcher__tab-link"
                                                target={tab.openInNewTab?.value === 'true' ? '_blank' : '_self'}
                                                rel={tab.openInNewTab?.value === 'true' ? 'noopener noreferrer' : undefined}
                                            >
                                                {tab.linkText.value}
                                            </a>
                                        )}
                                    </div>
                                    {tab.image?.value && (
                                        <img
                                            className="snippet-tab-switcher__tab-image"
                                            src={tab.image.value}
                                            alt={tab.alt?.value ? tab.alt.value : ''}
                                            height={300}
                                            width={300}
                                        />
                                    )}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SnippetTabSwitcher